import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SetLogin } from "../features/userSlice";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import Button from "@mui/material/Button";
import { updateLoginStatus } from "../Backend/addDataToFirebase";

const Login = () => {
  const [formData, setForm] = useState({
    email: "",
    password: "",
    check: false,
  });
  const [showPassword, setShowPassword] = useState("password");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlerForm = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlerSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      const user = userCredential.user;
      await updateLoginStatus(user.email, true);
      localStorage.setItem("user", JSON.stringify(user.email));
      navigate("/");
    } catch (error) {
      console.log(error.code, error.message);
      alert("Please enter valid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Left>
        <Overlay />
        <ContentWrapper>
          <LogoContainer>
            <Logo>
              <img src="/assets/logo.png" alt="Company Logo" />
            </Logo>
          </LogoContainer>
          <Header>
            <h1>Delivering safety. Delivering trust.</h1>
            <p>— Suman Pacheria, Founder Shree Mangal Murti Gases</p>
          </Header>
        </ContentWrapper>
        <BgImg>
          <img src="/assets/gas.png" alt="Gas Cylinder" />
        </BgImg>
      </Left>

      <Right>
        <BgImg2>
          <img src="/assets/gas.png" alt="Gas Cylinder" />
        </BgImg2>

        <FormContainer>
          <Form onSubmit={handlerSubmit}>
            <FormHeader>
              <h2>Welcome Back</h2>
              <p>Please enter your credentials to access your account</p>
            </FormHeader>

            <FormGroup>
              <Label htmlFor="email">Email Address</Label>
              <InputWrapper>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="john.doe@company.com"
                  value={formData.email}
                  onChange={handlerForm}
                  required
                />
              </InputWrapper>
            </FormGroup>

            <FormGroup>
              <Label htmlFor="password">Password</Label>
              <PasswordInputWrapper>
                <input
                  name="password"
                  id="password"
                  type={showPassword}
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handlerForm}
                  required
                  autoComplete="off"
                />
                <TogglePassword>
                  {showPassword === "password" ? (
                    <VisibilityIcon onClick={() => setShowPassword("text")} />
                  ) : (
                    <VisibilityOffIcon onClick={() => setShowPassword("password")} />
                  )}
                </TogglePassword>
              </PasswordInputWrapper>
            </FormGroup>

            <StyledButton
              variant="contained"
              type="submit"
              disabled={loading}
            >
              {loading ? "SIGNING IN..." : "SIGN IN"}
            </StyledButton>

            
          </Form>
        </FormContainer>
      </Right>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

const Left = styled.div`
  position: relative;
  width: 50%;
  background: linear-gradient(135deg, #eb0c10e6 0%, #b10b0ee6 100%);
  color: #fff;
  display: flex;
  align-items: top;
  justify-content: center;
  overflow: hidden;

  padding-bottom: 120px;   /* Push content upward */
`;
const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%);
  pointer-events: none;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  max-width: 500px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  transform: translateY(80px);   /* POSITIVE = move down */
`;

const LogoContainer = styled.div`
  width: 150px;
  height: 150px;
  margin-bottom: 40px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  border: 4px solid rgba(255, 255, 255, 0.3);
`;

const Logo = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Header = styled.div`
  h1 {
    color: white;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 20px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
  }

  p {
    color: rgba(255,255,255,0.9);
    font-size: 16px;
    font-style: italic;
    line-height: 1.6;
  }
`;

const BgImg = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.3;
  pointer-events: none;
  z-index: 1;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    transform: translateY(35px) scale(1.2);
  }
`;

const Right = styled.div`
  position: relative;
  width: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const BgImg2 = styled(BgImg)`
  transform: rotate(180deg) scaleX(-1);
  top: 0;
  bottom: unset;
  opacity: 0.1;
  position: absolute;
`;

const FormContainer = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 440px;
  padding: 40px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;

  h2 {
    color: #2d3748;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  p {
    color: #718096;
    font-size: 14px;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
`;

const InputWrapper = styled.div`
  input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.3s ease;
    outline: none;

    &:focus {
      border-color: #eb0c10;
      box-shadow: 0 0 0 3px rgba(235, 12, 16, 0.1);
    }

    &::placeholder {
      color: #a0aec0;
    }
  }
`;

const PasswordInputWrapper = styled(InputWrapper)`
  position: relative;

  input {
    padding-right: 45px;
  }
`;

const TogglePassword = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  
  .MuiSvgIcon-root {
    font-size: 20px;
    
    &:hover {
      color: #eb0c10;
    }
  }
`;

const StyledButton = styled(Button)`
  && {
    background: linear-gradient(135deg, #eb0c10 0%, #b10b0e 100%);
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(235, 12, 16, 0.25);
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(135deg, #b10b0e 0%, #eb0c10 100%);
      box-shadow: 0 6px 8px rgba(235, 12, 16, 0.3);
      transform: translateY(-1px);
    }

    &:disabled {
      background: #cbd5e0;
      box-shadow: none;
      transform: none;
    }
  }
`;

const Divider = styled.div`
  position: relative;
  text-align: center;
  margin: 8px 0;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e2e8f0;
  }

  span {
    position: relative;
    background: #fff;
    padding: 0 16px;
    color: #718096;
    font-size: 14px;
  }
`;

export default Login;